import React from 'react';
import c from 'classnames';

import { Icon, Button as RKSButton } from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink } from '@uncinc/react-drupal-core';
import { ButtonProps } from '../types';

const ButtonInner: React.FC<ButtonProps> = (props) => {
  const {
    type = 'primary',
    variant,
    icon,
    iconPosition = 'right',
    loading,
    disabled,
    className,
    ariaLabel,
    children,
    ...buttonProps
  } = props;

  const classNames = c(
    {
      [`Button--${type}`]: type !== 'primary',
      [`Button--variant--${String(variant)}`]: variant,
      [`Button--icon-position--${iconPosition}`]: icon,
      'Button--disabled': loading || disabled,
    },
    className,
  );

  if (type === 'text' && 'href' in buttonProps) {
    return (
      <CoreLink
        {...buttonProps}
        href={buttonProps.href}
        className={c('Button', classNames)}
        aria-disabled={disabled}
        aria-label={ariaLabel}
      >
        <>
          {variant !== 'icon-only' && children}

          {icon && (
          <Icon name={icon} />
          )}
        </>
      </CoreLink>
    );
  }

  return (
    <RKSButton
      {...buttonProps}
      primary={type === 'primary'}
      loading={loading}
      aria-disabled={disabled}
      className={classNames}
      aria-label={ariaLabel}
    >
      {variant !== 'icon-only' && children}

      {icon && (
        <Icon name={icon} />
      )}
    </RKSButton>
  );
};

export default ButtonInner;
